module.exports = __webpack_public_path__ + "img/Artistic-Swimming.3b744fb5.png";